import { PageTab } from "./nav-tabs.props";

export class AtlNavTabClickEvent extends CustomEvent<{
  tabIndex: number;
  tabName: string | undefined;
}> {
  static EVENT_NAME = "atlantis-nav-tab-click";

  constructor(tabIndex: number, tabName?: string) {
    super(AtlNavTabClickEvent.EVENT_NAME, {
      bubbles: true,
      composed: true,
      detail: { tabIndex, tabName },
    });
  }
}

export class AtlPageTabClickEvent extends CustomEvent<{
  tabIndex: number;
  pageTab: PageTab;
}> {
  static EVENT_NAME = "atlantis-page-tab-click";

  constructor(tabIndex: number, pageTab: PageTab) {
    super(AtlPageTabClickEvent.EVENT_NAME, {
      bubbles: true,
      composed: true,
      detail: { tabIndex, pageTab },
    });
  }
}
